import React, {Component, createRef} from "react";
import SelectionButton from "../gemeinde_email/SelectionButton";
import PropTypes from "prop-types";
import LinkCardMain from "../../../components/linkelement/LinkCardMain";

class GemForm extends Component {

  render() {
    return <div className={"bg-[#0d1117] min-h-screen flex items-center justify-center text-gray-200 font-mono " + this.props.className}>
      <div className="w-full max-w-2xl bg-[#161b22] rounded-lg shadow-lg border border-[#30363d] p-6">
        {this.props.children}
      </div>
    </div>;
  }
}

GemForm.propTypes = {
  className: PropTypes.string
}
export default GemForm;
